module.exports = __webpack_public_path__ + "img/left_circle1.76e38489.png";